import { useState, useEffect, Fragment } from "react";
import Container from "@mui/material/Container";
import CircularProgress from "@mui/material/CircularProgress";
import FleetWebApi from "../Api/FleetWebApi";
import CellConnection from "../Device/CellConnection";
import RadioDateRangePicker from "./RadioDateRangePicker";

function RadioInformation(props) {
  const [error, setError] = useState();
  const [measurementData, setMeasurementData] = useState();
  const [isLoading, setIsLoading] = useState();

  const [localStartDate, setLocalStartDate] = useState(new Date() - 12096e5);
  const [localEndDate, setLocalEndDate] = useState(new Date());
  const [localGetByArrivalDate, setLocalGetByArrivalDate] = useState(true);
  const [localRefreshCount, setLocalRefreshCount] = useState(0);

  const startDate = props.startDate !== undefined ? props.startDate : localStartDate;
  const endDate = props.endDate !== undefined ? props.endDate : localEndDate;
  const getByArrivalDate =
    props.getByArrivalDate !== undefined
      ? props.getByArrivalDate
      : localGetByArrivalDate;
  const refreshCount =
    props.refreshCount !== undefined ? props.refreshCount : localRefreshCount;

  const setStartDate = props.onStartDateChange || setLocalStartDate;
  const setEndDate = props.onEndDateChange || setLocalEndDate;
  const setGetByArrivalDate =
    props.onGetByArrivalDateChange || setLocalGetByArrivalDate;
  const forceRefresh = props.onRefresh || (() => setLocalRefreshCount((c) => c + 1));

  const showDatePicker = props.showDatePicker !== false;

  useEffect(() => {
    if (props.focused) {
      let element = document.getElementById("radioChart");
      while (element.firstChild) {
        element.removeChild(element.firstChild);
      }
      if (measurementData != null) {
        try {
          window.Bokeh.embed.embed_item(measurementData, "radioChart");
        } catch (error) {
          console.log(error);
          setError(error);
        }
      }
    }
  }, [measurementData, props.focused]);

  useEffect(() => {
    setIsLoading(true);
    setMeasurementData(null);
    let isMounted = true;
    FleetWebApi.getRadioDataFromCoreId(props.coreId, startDate, endDate, props.productType, getByArrivalDate ? "arrivalDate" : "timestamp")
      .then((resp) => {
        if (isMounted) {
          setMeasurementData(resp);
          setError(null);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        if (isMounted) {
          console.log(error);
          setError(error.message);
          setIsLoading(false);
        }
      });
    return () => {
      isMounted = false;
      setMeasurementData(null);
    };
  }, [props.coreId, startDate, endDate, getByArrivalDate, refreshCount]);

  return (
    <Fragment>
      <CellConnection
        coreId={props.coreId}
        startDate={startDate}
        endDate={endDate}
      />
      <Container maxWidth="lg">
        <h2>Radio Data</h2>
      </Container>
      {showDatePicker && (
        <RadioDateRangePicker
          startDate={startDate}
          endDate={endDate}
          onStartDateChange={setStartDate}
          onEndDateChange={setEndDate}
          getByArrivalDate={getByArrivalDate}
          onGetByArrivalDateChange={setGetByArrivalDate}
          onRefresh={forceRefresh}
        />
      )}
      <Container maxWidth="lg">
        {isLoading && <CircularProgress />}
        {error && <p>Error Loading Data: {error}</p>}
        <div id="radioChart" className="bk-root"></div>
      </Container>
    </Fragment>
  );
}

export default RadioInformation;
